import React from 'react';
import './style.scss';

export interface UQSpacerProps {
  size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'; // Define size options
}

const UQSpacer: React.FC<UQSpacerProps> = ({ size = 'm' }) => {
  return <div className={`spacer spacer-${size}`} />;
};

export default UQSpacer;